import {openModal} from 'snippets/_containers/modal/modal';
import {formatMoney} from '@shopify/theme-currency';

const finalSaleTag = 'Final-Sale',
    translations = window.translations,
    localeUrl = window.localeUrl;

export const lineItemCardHtml = async (itemData, lineItemAddedQuantity = 0) => {
    // Populate line item into card
    let lineItemCard = '';

    // Get item image
    let lineItemImage = '';

    if (typeof itemData.image != 'undefined' && itemData.image != '') {
        lineItemImage = itemData.image;
    } else if(itemData.featured_image.url){
        lineItemImage = itemData.featured_image.url;
    }

    // Get item url
    const lineItemUrl = itemData.url;
    // Get item title
    const lineItemTitle = itemData.product_title;
    // Get item prices
    const lineItemPrice         = formatMoney(itemData.price, theme.moneyWithoutCurrency); // Current Price
    const lineItemOriginalPrice   = formatMoney(itemData.original_price, theme.moneyWithoutCurrency); // Original Price
    let lineItemComparePrice    = '';
    let lineItemComparePriceRaw = null;
    let lineItemVariantTitle = null;
    
    // Get variant title
    if ( itemData?.variant_title != null ) {
        lineItemVariantTitle = itemData.variant_title.replace(' / ', ', ');
    }

    // Get product handle
    const productHandle = itemData.handle;
    // Final Sale Product - Check if the product is final sale or not based on tags
    let isFinalSale = false;

    await fetch(localeUrl+'/products/'+ productHandle +'.js')
        .then(response => response.json())
        .then(product => {
        // get product compare at price max
            product.variants.forEach((value) => {
                if (itemData.id == value.id) {
                    lineItemComparePrice = formatMoney(value.compare_at_price, theme.moneyWithoutCurrency);
                    lineItemComparePriceRaw = value.compare_at_price;
                }
            });
        
            // Get product tags
            product.tags.forEach((value) => {
                if (value == finalSaleTag) {
                    isFinalSale = true;
                    return false;
                }
            });
        })
        .catch(error => {
            console.error(error);
        });

    lineItemCard += '<article class="card card--default card--line-item card--line-item--placeholder">';
    // Image with link
    lineItemCard += '<a tabindex="-1" href='+ lineItemUrl +'>';
    if ( lineItemImage !== null && lineItemImage != '' ) {
        lineItemCard += '<img class="line-item__image" src="'+ lineItemImage +'"/>';
    }
    lineItemCard += '</a>';
    lineItemCard += '<div class="">';
    // Title
    if ( lineItemTitle.length ) {
        lineItemCard += '<h3 class="card__title">'+ lineItemTitle +'</h3>';
    }

    // Meta
    lineItemCard += '<div class="card__metadata">';
    // Variant Title
    if ( lineItemVariantTitle ) {
        lineItemCard += '<p class="line-item__variant-title">'+ lineItemVariantTitle +'</p>';
    }

    // Quantity
    let lineItemQuantity;
    if ( lineItemAddedQuantity > 0 ) {
        lineItemQuantity = lineItemAddedQuantity;
    }else{
        lineItemQuantity = itemData.quantity;
    }
    lineItemCard += '<p class="line-item__added-quantity">'+ translations.shortQuantity +': '+ lineItemQuantity +'</p>';

    // Prices
    lineItemCard += '<div data-price-wrapper="" class="card__price">';
    if ( lineItemOriginalPrice != lineItemPrice) {
        lineItemCard += '<span class="visually-hidden" data-original-price-text="">Original Price</span>';
        lineItemCard += '<s data-original-price="">'+ lineItemOriginalPrice +'</s>';
    }else if( lineItemComparePriceRaw != null ){
        lineItemCard += '<span class="visually-hidden" data-compare-text="">Regular price</span>';
        lineItemCard += '<s data-compare-price="" class="card__price--sale">'+ lineItemComparePrice +'</s>';
    }
    lineItemCard += '<span data-product-price="" class="card__price--original">'+ lineItemPrice +'</span>';
    lineItemCard += '</div>';

    // Final Sale
    if ( isFinalSale == true ) {
        lineItemCard += '<div class="line-item__final-sale">';
        lineItemCard += '<span>'+ translations.finalSaleLabel +'</span>';
        lineItemCard += '</div>';
    }

    lineItemCard += '</div></div>';

    lineItemCard += '</article>';

    return lineItemCard;
};

// Get current cart information and output as html
export const cartSubtotalUpdate = (cartData) => {

    const _config = {
        cartCountSelector: '.cart__item-count',
        cartCountScreenReader: '.cart__item--count-sr'
    };

    // Get number of items in cart
    const cartItemsNum = parseInt(cartData.item_count);
    let cartItemsNumLabel;
    let cartItemsScreenReader;
    
    if (cartItemsNum > 1) {
        cartItemsNumLabel = translations.itemCountOther;
        cartItemsScreenReader = translations.itemCountOther;
    } else {
        cartItemsNumLabel = translations.itemCountOne;
        cartItemsScreenReader = translations.itemCountOne;
    }

    const subTotalLabel = translations.subTotalLabel;

    // Get items subtotal price
    const cartSubtotal = formatMoney(cartData.items_subtotal_price, theme.settingCurrencyFormat);
    const cartSubtotalContainers = document.querySelectorAll('.cart-subtotal__container');
    
    if (cartSubtotalContainers.length) {
        cartSubtotalContainers.forEach(container => {
            container.querySelector('.cart-info__item-count').textContent = `${subTotalLabel} (${cartItemsNum} ${cartItemsNumLabel})`;
            container.querySelector('.cart-info__subtotal').textContent = cartSubtotal;
        });
    }

    // Update cart counts
    const cartCounts = document.querySelectorAll(_config.cartCountSelector);
    const cartCountsScreenReader = document.querySelectorAll(_config.cartCountScreenReader);
    if (cartCounts?.length > 0) {
        cartCounts.forEach((cartCount) => {
            cartCount.textContent = cartData.item_count; 
        });
        
        cartCountsScreenReader.forEach((cartCountScreen) => {
            cartCountScreen.textContent = `${cartData.item_count} ${cartItemsScreenReader}`; 
        });
    }
};


document.addEventListener('DOMContentLoaded', () => {

    Shopify.AjaxifyCart = () => {
        
        const _config = {

            // What you might want to change
            addToCartBtnLabel             : translations.addToCart,
            addedToCartBtnLabel           : translations.addingToCart,
            addingToCartBtnLabel          : translations.addingToCart,
            soldOutBtnLabel               : translations.soldOut,
            howLongTillBtnReturnsToNormal : 800, // in milliseconds.
            cartCountSelector             : '.cart__item-count',
            cartCountScreenReader         : '.cart__item--count-sr',
            cartTotalSelector             : '#cart-price',

            // What you will never need to change
            addToCartBtnSelector          : '.btn--add-to-cart--quick',
            addToCartFormSelector         : 'form[action="/cart/add"]',
            shopifyAjaxAddURL             : localeUrl+'/cart/add.js',
            shopifyAjaxCartURL            : localeUrl+'/cart.js',
            productPriceWrapper           : '[data-price-wrapper]',
            productComparePrice           : '[data-compare-price]',
            productQuantityInput          : 'input[name="quantity"]',

            // Cart Confirmation Modal configs
            cartModal                     : '.modal--cart-confirmation',
            cartModalMessage              : '.cart-confirmation__message',
            cartModalItem                 : '.cart-confirmation__item',
            cartModalCartInfo             : '.cart-subtotal__container',
        };

        // We need some feedback when adding an item to the cart.
        // Here it is.
        const _showFeedback = (itemData) => {

            document.querySelector(_config.cartModalMessage).innerHTML = translations.modalSuccessMessage + ' <svg class="icon icon__check--circle"><use xlink:href="#icon-check--circle"></use></svg>';

            // Get product quantity added to cart
            const lineItemAddedQuantity = document.querySelector(_config.addToCartFormSelector).querySelector(_config.productQuantityInput).value;

            // Get Added Item info and append to the modal
            lineItemCardHtml(itemData, lineItemAddedQuantity).then((lineItemCardHtml) => {
                document.querySelector(_config.cartModalItem).innerHTML = lineItemCardHtml;

                // Open the modal after the item is added
                const modal = document.querySelector(_config.cartModal);
                openModal(modal);
            });
        };

        const _setText = function(button, label) {
            if (button?.children.length) {
                button.children.forEach(function(child) {
                    if (child.textContent.trim() !== '') {
                        child.textContent = label;
                    }
                });
            } else if(button) {
                button.textContent = label;
            }
        };

        var _init = function() {
            // Empty the cart if there are only free sample products in cart
            fetch(_config.shopifyAjaxCartURL, {
                method: 'GET',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => response.json())
                .then(cart => {
                    const cart_items_subtotal_price = cart.items_subtotal_price;
                    const cart_item_count = cart.item_count;
                    if (cart_items_subtotal_price == 0 && cart_item_count > 0) {
                        fetch(localeUrl+'/cart/clear.js', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify({})
                        })
                            .then(() => {
                                location.reload(true);
                            })
                            .catch(error => {
                                console.error(error);
                            });
                    }
                })
                .catch(error => {
                    console.error(error);
                });
            
            // Loop through all ATC forms, in case quick ATC is present in product cards.
            const addToCartForms = document.querySelectorAll(_config.addToCartFormSelector);
            
            addToCartForms.forEach((addToCartForm) => {
                
                if ( addToCartForm.dataset.isAjax == 'true' ) {

                    addToCartForm.addEventListener('submit', function(e){
                        e.preventDefault();

                        // Remove error message
                        if( addToCartForm.querySelector('.cart__message--error') ) {
                            addToCartForm.querySelector('.cart__message--error').textContent = '';
                        }

                        const addToCartBtn = addToCartForm.querySelector(_config.addToCartBtnSelector),
                            addToCartText     = addToCartForm.querySelector('[data-add-to-cart-text]'),
                            addToCartBtnCard  = addToCartForm.querySelector('.quick-cart-add__loader'),
                            addToCartType     = addToCartForm.dataset.AddCartType;

                        // Get current label to reapply after cart submitted
                        _config.addToCartBtnLabel = addToCartText.textContent;

                        if (document.body.classList.contains('template-product') && addToCartForm.classList.contains('quick-cart-add__product-hero')) {
                            _setText(addToCartText, _config.addingToCartBtnLabel);
                        } else if (addToCartForm.getAttribute('data-add-cart-type') == 'modal') { // Cart Modal case
                            // Change Button Text to indicate that product is adding to cart
                            _setText(addToCartText, _config.addingToCartBtnLabel);
                            addToCartBtn.classList.add('disabled');
                            addToCartBtn.disabled = true;
                            addToCartBtn.classList.add('button--active');
                        } else {
                            _setText(addToCartBtnCard, _config.addingToCartBtnLabel);
                        }

                        // Add to cart.              
                        const formData = new FormData(addToCartForm);
                        
                        // Objectify Form Input data
                        let formObject = {};
                        formData.forEach((value, key) => {
                            if(!Reflect.has(formObject, key)){
                                formObject[key] = value;
                                return;
                            }
                            if(!Array.isArray(formObject[key])){
                                formObject[key] = [formObject[key]];    
                            }
                            formObject[key].push(value);
                        });
                        
                        // Required Shopify Format for Form payload
                        const formPayload = {
                            'items': [formObject]
                        }; 

                        fetch(_config.shopifyAjaxAddURL, {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify(formPayload)
                        })
                            .then((response) => {
                                if(response.status!==200) {
                                    throw response;
                                } else {
                                    return response.json();
                                }
                            })
                            .then((jsonResponse) => {
                                const itemData = jsonResponse.items[0];
                          
                                addToCartBtnCard?.classList.add('button--active');
                            
                                if (addToCartForm.getAttribute('data-add-cart-type') == 'modal') {
                                    // Update free shipping progress
                                    Shopify.freeShippingProgress().init();
                                }

                                if (document.body.classList.contains('template-product') && addToCartForm.classList.contains('quick-cart-add__product-hero')) {
                                    _setText(addToCartText, _config.addedToCartBtnLabel);
                                    addToCartBtn.classList.add('disabled');
                                    addToCartBtn.disabled = true;
                                    addToCartBtn.classList.add('button--active');
                                } else {
                                    _setText(addToCartBtnCard, _config.addedToCartBtnLabel);
                                }

                                window.setTimeout(function(){

                                    addToCartBtnCard?.classList.remove('button--active');
                                    addToCartBtn.classList.remove('button--active');
                                    addToCartBtn.classList.remove('disabled');
                                    addToCartBtn.disabled = false;

                                    if (document.body.classList.contains('template-product') && addToCartForm.classList.contains('quick-cart-add__product-hero')) {
                                        _setText(addToCartText, _config.addToCartBtnLabel);
                                    } else if (addToCartForm.getAttribute('data-add-cart-type') == 'modal') { // Cart Modal case
                                        _setText(addToCartText, _config.addToCartBtnLabel);
                                        _showFeedback(itemData);

                                        // ---------------------------------------------
                                        // Trap Focus inside the Cart Confirmation Modal
                                        // ---------------------------------------------

                                        // add all the elements inside modal which you want to make focusable
                                        const  focusableElements    = '[tabindex]:not([tabindex="-1"]), [href], button';
                                        const modal                 = document.querySelector('#modal_cart_confirmation'); // select the modal by it's id
                                        const firstFocusableElement = modal.querySelectorAll(focusableElements)[0]; // get first element to be focused inside modal
                                        const focusableContent      = modal.querySelectorAll(focusableElements);
                                        const lastFocusableElement  = focusableContent[focusableContent.length - 1]; // get last element to be focused inside modal

                                        document.addEventListener('keydown', function(e) {
                                            let isTabPressed = e.key === 'Tab' || e.keyCode === 9;

                                            if (!isTabPressed) {
                                                return;
                                            }

                                            if (e.shiftKey) { // if shift key pressed for shift + tab combination

                                                if (document.activeElement === firstFocusableElement) {

                                                    lastFocusableElement.focus(); // add focus for the last focusable element
                                                    e.preventDefault();
                                                }
                                            } else { // if tab key is pressed

                                                if (document.activeElement === lastFocusableElement) { // if focused has reached to last focusable element then focus first focusable element after pressing tab

                                                    firstFocusableElement.focus(); // add focus for the first focusable element
                                                    e.preventDefault();
                                                }
                                            }
                                        });
                                    }
                                }, _config.howLongTillBtnReturnsToNormal);

                                // Update cart count
                                fetch(_config.shopifyAjaxCartURL, {
                                    cache: 'no-cache',
                                    headers: {
                                        'Content-Type': 'application/json'
                                    }
                                })
                                    .then((response) => response.json())
                                    .then((cart) => {
                                        const cartCountSelector = document.querySelectorAll(_config.cartCountSelector);
                                
                                        if (cartCountSelector && cartCountSelector.length > 0) {
                                            cartCountSelector.forEach((cartCount) => {
                                                cartCount.textContent = cart.item_count;
                                            }); 
                                        }
                                    });
                            })
                            .catch(async (error) => {
                                try {
                                    const errorObject = await error.json();
                                    if (errorObject?.description) {
                                        const errorDescription = errorObject.description;
                                    
                                        if (errorDescription.slice(0,4) === 'All ') {
                                            if( document.querySelector('.cart__message--error') ) {
                                                document.querySelector('.cart__message--error').textContent = "You can't add more of this product to the cart.";
                                            }
                                            _setText(addToCartText, _config.soldOutBtnLabel);
                                            addToCartBtn.disabled = true;
                                            return;
                                        } else {
                                            if( document.querySelector('.cart__message--error') ) {
                                                document.querySelector('.cart__message--error').textContent = errorDescription;
                                            }
                                            addToCartBtn.disabled = false;
                                            addToCartBtn.classList.remove('disabled');
                                            _setText(addToCartText, _config.addToCartBtnLabel);
                                            return;
                                        }
                                    } 
                                } catch {
                                    console.error(error);
                                }
                            
                            });
                        return false;
                    });
                }
            });
        };
        return {
            init: (params) => {
                // Configuration
                params = params || {};
                // Merging with defaults.
                Object.assign(_config, params);
                // Action
                _init();
            },
            getConfig: () => {
                return _config;
            }
        };
    };
    Shopify.AjaxifyCart().init();
});
